<style lang="less">
    @import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="monitor">
        <ul class="main_group">
            <li class="main_item">
                <span class="item_title" style="padding-left: 30px;">选择监测类型：</span>
                <div class="item_content">
                    <RadioGroup class="radio_group monitor_type"
                                v-model="monitorType"
                                @on-change="monitorTypeChange">
                        <Radio v-for="(item,index) in monitorTypeList" class="radio_item" :label="item.value">
                            <span class="radio_item_name">{{ item.name }}</span></Radio>
                    </RadioGroup>
                </div>
            </li>
            <!--     图片监测       -->
            <li v-if="monitorType == 'image' ">
                <ol>
                    <li style="border-bottom: none" class="main_item">
                        <span class="item_title" style="padding-left: 30px;">确认监测作品：</span>
                        <div class="item_content">
<!--                            <RadioGroup class="radio_group works_type" v-model="worksType"-->
<!--                                        @on-change="worksTypeChange">-->
<!--                                <Radio v-for="(item,index) in worksTypeList" class="radio_item" :label="item.value">-->
<!--                                    <span-->
<!--                                            class="radio_item_name">{{ item.name }}</span></Radio>-->
<!--                                &lt;!&ndash;                                <Radio class="radio_item"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                       :label="2"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                       value="申请版权证书"><span&ndash;&gt;-->
<!--                                &lt;!&ndash;                                        class="radio_item_name">在线申请<span&ndash;&gt;-->
<!--                                &lt;!&ndash;                                        class="text_decoration">版权电子证书</span>（免费）</span></Radio>&ndash;&gt;-->
<!--                            </RadioGroup>-->
<!--                            <div class="prompt_text"></div>-->
                            <!--                            <div class="prompt_text">如您的作品没有申请版权证书，可以免费在版权家申请由版权保护中心颁发的电子版版权证书</div>-->
                            <div class="upload_group">
<!--                                <div class="upload_item">-->
<!--                                    <i-input v-model="dciCode" placeholder="请输入登记号或DCI编码"></i-input>-->
<!--                                    <div class="upload_certificate_box">-->
<!--                                        <MyUploadOneHw accept=".jpg,.jpeg,.png"-->
<!--                                                       :pictureSize="20971520"-->
<!--                                                       :width="175"-->
<!--                                                       :height="154"-->
<!--                                                       border="1px dashed #B9B9B9"-->
<!--                                                       addIcon="addFile"-->
<!--                                                       tipsText="上传证书"-->
<!--                                                       :preImg="dciCertificate"-->
<!--                                                       @listenImgUrl="showMessageFromCertificateChild"></MyUploadOneHw>-->
<!--                                    </div>-->
<!--                                    <div>登记号与证书必填1项</div>-->
<!--                                </div>-->
                                <div class="upload_item">
                                    <div class="upload_works_box">
                                        <MyUploadOneHw accept=".jpg,.jpeg,.png"
                                                       :pictureSize="20971520"
                                                       :width="175"
                                                       :height="154"
                                                       border="1px dashed #B9B9B9"
                                                       addIcon="addFile"
                                                       tipsText="请上传作品图片"
                                                       :preImg="photoWorks"
                                                       @listenImgUrl="showMessageFromWorksChild"></MyUploadOneHw>

                                        <div class="upload_works_text">
                                            <div>温馨提示：</div>
                                            <ol class="upload_works_text_group">
                                                <li>1、支持上传格式png、jpg、jpeg；</li>
                                                <li>2、上传文件大小不得超过20M；</li>
                                                <li>3、图片尺寸需大于200*200。</li>
                                            </ol>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </li>
                    <li style="border-bottom: 1px solid #EEEEEE;" class="main_item">
                        <span class="item_title title_center" style="padding-left: 50px;">设定关键词：</span>
                        <div class="item_content">
                            <i-input maxlength="20" v-model="monitorName" placeholder="输入图片描述（作品名称、作者等）"></i-input>
                        </div>
                    </li>
                </ol>

                <!--        我的作品弹框        -->
                <Modal
                        class="my_works_modal"
                        v-model="worksModal"
                        :footer-hide="true"
                        @on-cancel="modalClose"
                        width="915">

                    <div class="modal_title">
                        <span class="main_title">我的作品</span>
                        <span class="subheading">只能选择一个作品</span>
                    </div>

                    <div class="modal_main">
                        <Row class="table-style-size">
                            <i-col span="7">作品名称</i-col>
                            <i-col span="4">作品类型</i-col>
                            <i-col span="5">证书类型</i-col>
                            <i-col span="4">证书</i-col>
                            <i-col span="4">作品</i-col>
                        </Row>

                        <RadioGroup class="modal_radio_group" v-model="modelWorksChoice" @on-change="modelWorksChange">
                            <Row v-for="(item,index) in [1,2,3,4,5,6,7,8,9,10]"
                                 class="table-style-size table-style-body" style="height:65px">
                                <i-col span="7">
                                    <Radio :label="item" class="radio_item"><span class="radio_item_name">密西西比河</span>
                                    </Radio>
                                </i-col>
                                <i-col span="4">摄影作品</i-col>
                                <i-col span="5">纸质证书</i-col>
                                <i-col class="text_underline" span="4">点击查看</i-col>
                                <i-col span="4">
                                    <img class="pictures_img"
                                         src=""
                                          alt='版权登记'>
                                </i-col>
                            </Row>

                        </RadioGroup>
                    </div>

                    <div class="modal_footer">
                        <div class="commont-page" style="padding: 30px 0;">
                            <Page @on-change="changepage" :total="total" size="small" show-total show-elevator
                                  class="page-size-style"></Page>
                            <span class="page-total-span">/&nbsp;{{pages}}页</span>
                        </div>
                    </div>


                </Modal>
            </li>

            <!--     音乐监测       -->
            <li v-else-if="monitorType == 'music' ">
                <ol>
                    <li class="main_item">
                        <span class="item_title title_center" style="padding-left: 40px;">歌曲名称：</span>
                        <div class="item_content">
                            <i-input maxlength="20" v-model="musicName" placeholder=""></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title title_center" style="padding-left: 40px;">歌手姓名：</span>
                        <div class="item_content">
                            <i-input maxlength="20" v-model="musicSingerName" placeholder=""></i-input>
                        </div>
                    </li>
                    <li style="border-bottom: 1px solid #EEEEEE;" class="main_item">
                        <span class="item_title title_center" style="padding-left: 40px;">设定监测名称：</span>
                        <div class="item_content">
                            <i-input maxlength="20" v-model="monitorName" placeholder="监测名称可以区分您多次监测的内容"></i-input>
                        </div>
                    </li>
                </ol>
            </li>

            <!--     文字监测       -->
            <li v-else-if="monitorType == 'word' ">
                <ol>
                    <li class="main_item">
                        <span class="item_title title_center" style="padding-left: 52px;">监测关键词：</span>
                        <div class="item_content">
<!--                            <Input v-model="textWorks" class="textarea" maxlength="2000" show-word-limit type="textarea"-->
<!--                                   placeholder="限2000个字" style="width: 760px;min-height: 270px;"/>-->
                            <i-input maxlength="20" v-model="textWorks" placeholder="请输入监测关键词，限20个字内"></i-input>


                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title title_center" style="padding-left: 40px;">设定监测名称：</span>
                        <div class="item_content">
                            <i-input maxlength="20" v-model="monitorName" placeholder="监测名称可以区分您多次监测的内容"></i-input>
                        </div>
                    </li>
                </ol>
            </li>


            <li class="main_item">
                <span class="item_title" style="padding-left: 40px;padding-top: 9px;">选择监测范围：</span>
                <div class="item_content">
                    <div class="checkbox_box">
                        <CheckboxGroup v-model="scopesType">
                            <Checkbox v-for="(item,index) in scopesList" :label="item.id">
                                <span>{{ item.name }}</span>
                            </Checkbox>
                        </CheckboxGroup>
                    </div>
                </div>
            </li>
            <li v-show="userInfo && userInfo!='' " class="main_item">
                <span class="item_title" style="padding-left: 40px;padding-top: 9px;">支付方式：</span>
                <div class="item_content">
                    <component :is="payWay" key="image" v-if="monitorType === 'image'" @onselected="imagePayWay = $event" type="0401"></component>
                    <component :is="payWay" key="music" v-if="monitorType === 'music'" @onselected="musicPayWay = $event" type="0403"></component>
                    <component :is="payWay" key="word" v-if="monitorType === 'word'" @onselected="wordPayWay = $event" type="0402"></component>
                </div>
            </li>

        </ul>

        <div @click="checkSubmit" class="submit_btn">开始监测</div>

        <!--    加油包    -->
        <monitorBag bizType="04" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
        <!--    会员续费    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>

    </div>
</template>

<script>

    import {_getScopes, _insertOrUpdate, _getContent} from "@/api/monitor.js";
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
    import MyUploadOneHw from '@/views/main-components/my-upload-one-hw';
    import payWay from '@/views/main-components/pay-way';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay'
    import Cookies from "js-cookie";
    export default {
        metaInfo: {
            title: '版权监测|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            },{
                name: 'Description',
                content: '版权监测,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "monitor",
        components: {
            MyUploadOneHw,
            monitorBag,
            myczPay,
            payWay
        },
        data() {
            return {
                monitorId: '', //监测id
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                monitorTypeList: [
                    {name: '图片监测', value: 'image'},
                    {name: '音乐监测', value: 'music'},
                    {name: '文字监测', value: 'word'},
                ], //监测类型选择列表
                monitorType: '', //当前选中监测类型
                monitorName: '', //监测名称
                dciCode: '', //DCI编码
                dciCertificate: '', //DCI证书
                photoWorks: '', //图片作品路径
                worksTypeList: [
                    {name: '已取得版权证书', value: 0},
                    // {name: '从我的作品选择', value: 1}
                ], //监测作品选择列表
                worksType: 0, //当前选中监测作品类型
                musicName: '', //歌曲名称
                musicSingerName: '', //歌手名称
                textWorks: '', //文本监测-作品
                worksModal: false, //从我的作品选择模态框状态
                scopesList: [], //监测范围列表
                scopesType: [], //当前选中监测范围
                modelWorksChoice: '', //我的作品模态框选择值
                pageNumber: 1,
                pageSize: 10,
                total: 0,
                pages: 1,
                monitorBagState: false, //加油包模态框展示状态
                myczPayState: false, //会员监测模态框展示状态
                btnFlag:true, //防止重复点击
                imagePayWay: null,// 支付方式
                musicPayWay: null,
                wordPayWay: null,
                payWay:''
            }
        },
        watch:{
	    	"$store.state.app.showPayWay":function(){
	    		if(Cookies.get("userInfo")){
	    			this.userInfo = JSON.parse(Cookies.get("userInfo")),
	    			this.payWay = 'payWay'
	    		}
	    	}
	    },
        created() {
           /* if (this.$route.query.id && this.$route.query.id != '') {
                this.monitorId = this.$route.query.id;
                this.getContent();
            }else{
            }*/
    		this.monitorType = 'image';
        	this.getScopes();
//          console.log(this.$store.state.app.showPayWay)
            this.$store.state.app.showPayWay =Cookies.get("userInfo") && Cookies.get("userInfo") != ''? true : false
            this.payWay = this.$store.state.app.showPayWay == true? 'payWay':''
            
        },
        methods: {
            /****************监测类型改变事件**************/
            monitorTypeChange(value) {
                console.log(value);

                this.monitorName = '';
                this.dciCode = '';
                this.dciCertificate = '';
                this.photoWorks = '';
                this.musicName = '';
                this.musicSingerName = '';
                this.textWorks = '';
                this.scopesList = [];
                this.scopesType = [];
                this.getScopes();
            },

            /****************监测作品改变事件**************/
            worksTypeChange(value) {
                console.log(value);
                //从我的作品选择
                if (value == 1) {
                    this.worksModal = true;
                    this.modelWorksChoice = '';
                }
                //在线申请版权电子证书（免费）
                else if (value == 2) {
                    setTimeout(res => {
                        const {href} = this.$router.resolve({
                            name: "copyrightRegistration",
                            // query:{id:1}
                        });
                        this.worksType = 0;
                        window.open(href, '_blank');
                    }, 1)

                }

            },

            /****************获取监测范围**************/
            getScopes() {
                let data = {
                    type: this.monitorType
                };
                _getScopes(data).then(res => {
                    if (res.code == 200) {
                        let records = res.result.records;
                        this.scopesList = records;
						
                        this.scopesReset(this.scopesType);

                    }
                })
            },

            /****************模态框-单选改变事件**************/
            modelWorksChange(value) {
                console.log(value);
                this.worksModal = false;
            },

            /****************模态框-翻页改变事件**************/
            changepage(index) {
                this.pageNumber = index;
                // this.getByPage()
            },

            /****************上传证书-接收华为云组件传值**************/
            showMessageFromCertificateChild(value) {
                this.dciCertificate = value;
            },

            /****************上传作品图片-接收华为云组件传值**************/
            showMessageFromWorksChild(value) {
                this.photoWorks = value;

            },

            /****************模态框关闭事件**************/
            modalClose(value) {
                let modelWorksChoice = this.modelWorksChoice;
                if (modelWorksChoice == '') {
                    this.worksType = 0;
                }
            },

            /****************监测提交点击事件**************/
            checkSubmit() {
                /*let monitor = {
                	type : this.monitorType,
                	scopeIds : this.scopesType,
                	workImage : this.photoWorks,
                	monitorName : this.monitorName,
                	musicName : this.musicName,
                	musicAuthor : this.musicSingerName,
                	textContent : this.textWorks,
                }*/
//              console.log(data)
                if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                    this.userInfo = JSON.parse(Cookies.get("userInfo"));
                }
                else{
                    this.$store.state.app.showLoginOrRegistter = true
                    return false;
                }

                let data = {
                    scopeIds: this.scopesType,
                    id: '',
                    type: this.monitorType,
                    dicCode: this.dciCode,
                    dicCert: this.dciCertificate,
                    workImage: this.photoWorks,
                    textContent: this.textWorks.replace(/^\s+|\s+$/g,''),
                    musicName: this.musicName.replace(/^\s+|\s+$/g,''),
                    musicAuthor: this.musicSingerName.replace(/^\s+|\s+$/g,''),
                    monitorName: this.monitorName.replace(/^\s+|\s+$/g,''),
                    remarks: '',
                    registerId: this.userInfo.id
                };


                switch (data.type) {

                    case 'image': {
                        if (/**(data.dicCode != '' || data.dicCert != '') && **/ data.workImage != '' && data.monitorName != '' && data.scopeIds.length != 0) {
                            if (this.imagePayWay && this.imagePayWay.gift) {
                                if (!this.imagePayWay.gift.isVipRight) {
                                    Object.assign(data, {activityGiftId: this.imagePayWay.gift.activityGiftId})
                                }
                            }
                            else{
                                toast('无可用次数');
                                return
                            }
                            break;
                        } else {
                            toast('请填写完整后再提交');
                            return false;
                        }
                    }

                    case 'music' : {
                        if (data.musicName != '' && data.musicAuthor != '' && data.monitorName != '' && data.scopeIds.length != 0) {
                            if (this.musicPayWay && this.musicPayWay.gift) {
                                if (!this.musicPayWay.gift.isVipRight) {
                                    Object.assign(data, {activityGiftId: this.musicPayWay.gift.activityGiftId})
                                }
                            }
                            else{
                                toast('无可用次数');
                                return
                            }
                            break;
                        } else {
                            toast('请填写完整后再提交');
                            return false;
                        }
                    }

                    default:
                        if(data.textContent.length <2){
                            toast('监测关键词最少输入两个字符');
                            return
                        }
                        if (data.textContent != '' && data.monitorName != '' && data.scopeIds.length != 0) {
                            if (this.wordPayWay && this.wordPayWay.gift) {
                                if (!this.wordPayWay.gift.isVipRight) {
                                    Object.assign(data, {activityGiftId: this.wordPayWay.gift.activityGiftId})
                                }
                            }
                            else{
                                toast('无可用次数');
                                return
                            }
                            break;
                        } else {
                            toast('请填写完整后再提交');
                            return false;
                        }
                }

                if(!this.btnFlag){
                    return
                }
                _insertOrUpdate(data).then(res => {
                    let message = res.message;
                    let _this = this;

                    //1.用户未实名；2.VIP未开通；3.VIP已到期；4.加油包

                    switch (res.code) {
                        case 200 : {
                            this.$router.push({path: '/monitoring', query: {id: res.result.id}});
                            break;
                        }
                        //用户未实名认证
                        case 213 : {
                            // toast(message, () => {
                            //     const {href} = this.$router.resolve({
                            //         name: "authentication",
                            //         // query:{id:1}
                            //     });
                            //     window.open(href, '_blank');
                            //
                            // });

                            break;
                        }

                        //VIP未开通
                        case 214: {
                            // toast(message, () => {
                            //     if (this.userInfo.accountType == 'person') {
                            //         console.log(this.$router.resolve);
                            //         const {href} = this.$router.resolve({
                            //             name: "vipone",
                            //             // query:{id:1}
                            //         });
                            //         window.open(href, '_blank');
                            //     } else {
                            //         const {href} = this.$router.resolve({
                            //             name: "viptwo",
                            //             // query:{id:1}
                            //         });
                            //         window.open(href, '_blank');
                            //
                            //     }
                            // });
                            break;

                        }

                        //VIP已到期--弹框
                        case 215: {
                            toast(message, () => {
                                this.myczPayState = true;
                            });
                            break;
                        }

                        //次数不够--弹出加油包
                        case 216 : {
                            this.monitorBagState = true;
                            break;
                        }

                        default:
                            toast(message);
                            break;

                    }

                    this.btnFlag = true;
                }, (err) => {
                    toast('提交失败，请重试');
                    this.btnFlag = true;
                })
            },

            /****************接收加油包组件传值**************/
            monitorBagFuc(value) {
                this.monitorBagState = false;
            },


            /****************接收会员续费组件传值**************/
            myczPayFuc() {
                console.log('会员续费弹框');
                this.myczPayState = false;
            },

            /****************获取提交过得监测数据**************/
            getContent() {
                _getContent(this.monitorId).then(res => {
                    if (res.code == 200) {
                        let result = res.result;
                        let scopes = result.scopes;

                        /*this.monitorType = result.type;
                        this.dciCode = result.dicCode;
                        this.dciCertificate = result.dicCert;
                        this.photoWorks = result.workImage;
                        this.textWorks = result.textContent;
                        this.musicName = result.musicName;
                        this.musicSingerName = result.musicAuthor;
                        this.monitorName = result.monitorName;
                        this.scopesType = scopes;this.*/
                        this.monitorType = result.type;
                        this.dciCode = '';
                        this.dciCertificate = '';
                        this.photoWorks = '';
                        this.textWorks = '';
                        this.musicName = '';
                        this.musicSingerName = '';
                        this.monitorName = '';
                        this.scopesType = scopes;
                        
                        this.getScopes();
                        // if (this.scopesList && this.scopesList.length != 0) {
                        //     this.scopesReset(scopes);
                        // }
                    }
                })
            },

            /****************范围回显方法**************/
            scopesReset(resetData) {
                let scopesList = this.scopesList;
                let newScopesType = [];
	        	console.log(this.scopesType)
				
                if (resetData.length == 0) {
                    let arr = [];
                    arr.push(scopesList[0].id);
                    newScopesType = arr;
                } 
                /*  else {
                  for (let i = 0; i < resetData.length; i++) {
                        let nowItem = resetData[i];
                        for (let j = 0; j < scopesList.length; j++) {
                            let scopesListItem = scopesList[j];
                            if (nowItem == scopesListItem.name) {
                                newScopesType.push(scopesListItem.id);
                                break;
                            }
                        }
                    }
                }*/
               // this.scopesType = newScopesType;

            }
        },

    }
</script>

<style scoped lang="less">
    ol, ul {
        list-style: none;
    }

    .monitor {
        width: 1334px;
        margin: 20px auto 0;

    }

    .main_group {
        width: 100%;
        background: #fff;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
        list-style: none;
    }

    .main_group .main_item {
        padding: 20px 0;
        display: flex;
        border-bottom: 1px solid #EEEEEE;
    }

    .main_group .main_item:last-child {
        border: none;
    }

    .main_item .item_title {
        width: 162px;
        box-sizing: border-box;
        color: #666666;
        font-size: 14px;
    }

    .item_title.title_center {
        align-self: center;;
    }

    .main_item .item_content {
        flex: 1;
    }

    .item_content .checkbox_box {
        width: 760px;
        overflow: hidden;
    }

    .radio_group .radio_item_name {
        margin-left: 4px;
        font-size: 14px;
        color: #666;
    }

    .monitor_type .radio_item {
        margin-right: 72px;
    }

    .works_type .radio_item {
        margin-right: 30px;
    }

    .radio_item.ivu-radio-wrapper-checked .radio_item_name {
        /*color: #333;*/
    }

    /deep/ .radio_item .ivu-radio-inner {
        width: 12px;
        height: 12px;
        border-radius: 0;
        border: 1px solid #B5B5B5;
    }

    .radio_item .ivu-radio-checked .ivu-radio-inner {
        border-color: #FFD800;
    }

    /deep/ .radio_item .ivu-radio-inner:after {
        width: 12px;
        height: 12px;
        left: -1px;
        top: -1px;
        border-radius: 0;
        background-color: #FFD800;
    }

    .text_decoration {
        text-decoration: underline;
    }

    .item_content .prompt_text {
        color: #999999;
        font-size: 12px;
        line-height: 17px;
        padding: 15px 0;
    }

    .upload_group .upload_item {
        /*border-top: 1px solid #EEEEEE;*/
        padding-bottom: 20px;
        font-size: 12px;
        color: #999999;
    }

    .upload_group .upload_item:last-child {
        padding-bottom: 0;
    }

    /deep/ .ivu-input {
        width: 434px;
        height: 38px;
        /*border: 1px solid #CBCBCB;*/
        border-radius: 2px;
        box-shadow: none;
        font-size: 12px;
        /*line-height: 48px;*/
        color: #333;
        padding: 0 10px;
    }

    /deep/ .ivu-radio-focus{
        box-shadow: none;
    }

    /deep/ .ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #999999;
    }

    .ivu-input::-moz-placeholder { /* Firefox 19+ */
        color: #999999;
    }

    .ivu-input:-ms-input-placeholder { /* IE 10+ */
        color: #999999;
    }

    .ivu-input:-moz-placeholder { /* Firefox 18- */
        color: #999999;
    }

    .upload_item .upload_certificate_box {
        padding: 20px 0 15px;
        display: flex;
    }

    .upload_item .upload_works_box {
        /*padding: 20px 0;*/
        display: flex;

        .upload_works_text {
            align-self: flex-end;
            margin-left: 20px;
            color: #999999;
            font-size: 14px;
        }

        .upload_works_text_group {
            padding-top: 10px;
        }
    }

    /deep/ .checkbox_box .ivu-checkbox {
        display: none;
    }

    .checkbox_box .ivu-checkbox-wrapper {
        width: 136px;
        height: 40px;
        text-align: center;
        box-sizing: border-box;
        border: 1px solid #B9B9B9;
        vertical-align: top;
        margin: 0 20px 20px 0;
        border-radius: 4px;
    }

    /deep/ .checkbox_box .ivu-checkbox + span, .ivu-checkbox-wrapper + span {
        line-height: 40px;
        color: #999999;
        font-size: 14px;
    }

    /deep/ .checkbox_box .ivu-checkbox-wrapper-checked .ivu-checkbox + span, .ivu-checkbox-wrapper + span {
        color: #333333;
    }

    /deep/ .checkbox_box .ivu-checkbox-wrapper-checked {
        background: #FFD800;
        border: none;
        padding: 1px;
    }

    .submit_btn {
        background: #FFD800;
        color: #4E4E4E;
        width: 230px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        margin: 30px auto 50px;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
    }

    /deep/ .textarea .ivu-input {
        width: 760px;
        min-height: 270px;
        padding: 15px;
        line-height: 1.5;
        resize: none;
    }

    /deep/ .ivu-modal-body {
        padding: 0;
    }

    .my_works_modal .modal_title {
        padding: 15px 20px;
        background: #FFFFFF;
        box-shadow: 0 2px 18px 0 rgba(211, 214, 225, 0.15);
        border-radius: 8px 8px 0 0;
        font-size: 14px;
        color: #666666;
    }

    .modal_title .main_title {
        color: #333;
        padding-right: 15px;
    }

    .modal_radio_group.ivu-radio-group {
        display: block;
        vertical-align: auto;
    }

    .modal_radio_group .radio_item {
        margin-right: 0;
    }

    /deep/ .radio_item .ivu-radio {
        margin-right: 20px;
    }

    /deep/ .radio_item .ivu-radio-inner {
        width: 12px;
        height: 12px;
        border-radius: 0;
        border: 1px solid #B5B5B5;
    }

    .radio_item .ivu-radio-checked .ivu-radio-inner {
        border-color: #FFD800;
    }

    /deep/ .radio_item .ivu-radio-inner:after {
        width: 12px;
        height: 12px;
        left: -1px;
        top: -1px;
        border-radius: 0;
        background-color: #FFD800;
    }

    .table-style-body .text_underline {
        text-decoration: underline;
        cursor: pointer;
    }

    .table-style-body .pictures_img {
        width: 65px;
        height: 53px;
        display: inline-block;
        background: #D8D8D8;
        border-radius: 2px;
    }
</style>